module.exports = __webpack_public_path__ + "img/SHBVN.d93d7067.svg";